<div [formGroup]="form" #myFormReference>
    <p *ngIf="headline" class="subtitle mb-0 new-customer"><b>{{ headline }}</b></p>
    <article *ngIf="apiError" class="message is-danger">
        <div class="message-body">
            <b>{{ apiError.notification }}</b>
            <span *ngFor="let error of apiError.errors" class="is-block"><span
                    *ngIf="error.key !== 'email'">{{ error.key }}
                :</span> {{ error.error }}</span>
        </div>
    </article>
    <ng-container
            *ngIf="(config$ | async)?.customerRegisterTextTop && ((config$ | async)?.customerRegisterTextTop?.length ?? 0) >0">
        <div class="mt-2" [innerHTML]="(config$ | async)?.customerRegisterTextTop"></div>
    </ng-container>
    <div class="mt-2" formGroupName="address">
        <div class="field" [ngClass]="isHiddenOrDisabled('salutation')? 'is-hidden': ''">
            <label class="label">Anrede<span *ngIf="isRequired('salutation')">*</span></label>
            <div class="control">
                <div class="select" [ngClass]="isFormRequestError('address.salutation') ? 'is-danger' : ''">
                    <select formControlName="salutation" aria-label="Anrede auswählen">
                        <option value="">Bitte auswählen</option>
                        <option value="Frau">Frau</option>
                        <option value="Herr">Herr</option>
                        <option value="Divers">Divers</option>
                    </select>
                </div>
                <p *ngIf="isFormRequestError('address.salutation')"
                   class="help is-danger">{{ this.getFieldErrorMsg('salutation', 'Bitte hinterlegen Sie eine Anrede.') }}</p>
            </div>

        </div>
        <div class="is-flex-tablet">
            <div class="field is-flex-grow-1 pr-2-tablet" [ngClass]="isHiddenOrDisabled('firstName')? 'is-hidden': ''">
                <label class="label">Vorname<span *ngIf="isRequired('firstName')">*</span></label>
                <div class="control">
                    <input formControlName="firstName"
                           [ngClass]="isFormRequestError('address.firstName') ? 'is-danger' : ''"
                           class="input" type="text"
                           placeholder="Vorname" value=""/>
                    <p *ngIf="isFormRequestError('address.firstName')"
                       class="help is-danger">{{ this.getFieldErrorMsg('firstName', 'Bitte hinterlegen Sie einen Vornamen.') }}
                        .</p>
                </div>
            </div>
            <div class="field is-flex-grow-1 ml-4-tablet" [ngClass]="isHiddenOrDisabled('name')? 'is-hidden': ''">
                <label class="label">Nachname<span *ngIf="isRequired('name')">*</span></label>
                <div class="control">
                    <input formControlName="name" [ngClass]="isFormRequestError('address.name') ? 'is-danger' : ''"
                           class="input"
                           type="text"
                           placeholder="Nachname" value=""/>
                    <p *ngIf="isFormRequestError('address.name')"
                       class="help is-danger">{{ this.getFieldErrorMsg('name', 'Bitte hinterlegen Sie einen Namen.') }}</p>
                </div>
            </div>
        </div>
    </div>

    <div class="field" [ngClass]="isHiddenOrDisabled('dateOfBirth')? 'is-hidden': ''">
        <label class="label">Geburtsdatum<span *ngIf="isRequired('dateOfBirth')">*</span></label>
        <p-datepicker
            #datePicker
            (onShow)="selectYear()"
                formControlName="dateOfBirth"
                [defaultDate]="dateOfBirthMax"
                [showIcon]="true"
                [readonlyInput]="true"
                [minDate]="dateOfBirthMin"
                [maxDate]="dateOfBirthMax"
                ariaLabel="Geburtsdatum"
                dataType="date"
                dateFormat="dd.mm.yy"

        ></p-datepicker>
  <!--      <p class="control has-icons-left ">
            <input formControlName="dateOfBirth" [ngClass]="isFormRequestError('dateOfBirth') ? 'is-danger' : ''"
                   (click)="datePicker.open()"
                   readonly
                   matInput
                   class="input"
                   [max]="dateOfBirthMax"
                   [min]="dateOfBirthMin"
                   [matDatepicker]="datePicker"
                   type="text"
                   placeholder="Geburtsdatum"/>
            <span class="icon is-small is-left">
                <fa-icon [icon]="faCalendar" role="img" aria-label="Kalender öffnen"></fa-icon>
            </span>
            <mat-datepicker #datePicker [disabled]="false"
                            startView="multi-year"
                            [startAt]="dateOfBirthMax"
                            panelClass="endDate"></mat-datepicker>
        </p>-->
        <p *ngIf="isFormRequestError('dateOfBirth')"
           class="help is-danger">{{ this.getFieldErrorMsg('dateOfBirth', 'Bitte hinterlegen Sie ein Geburtsdatum.') }}</p>
    </div>


    <div formGroupName="address">
        <div class="field" [ngClass]="isHiddenOrDisabled('company')? 'is-hidden': ''">
            <label class="label">Firma<span *ngIf="isRequired('company')">*</span></label>
            <div class="control">
                <input formControlName="company" class="input" type="text" placeholder="Firma" value=""
                       [ngClass]="isFormRequestError('address.company') ? 'is-danger' : ''"/>
            </div>
        </div>
        <p *ngIf="isFormRequestError('address.company')"
           class="help is-danger">{{ this.getFieldErrorMsg('company', 'Bitte hinterlegen Sie eine Firma.') }}</p>
    </div>

    <div formGroupName="address" class="field mt-2" [ngClass]="isHiddenOrDisabled('phone')? 'is-hidden': ''">
        <label class="label">Telefon<span *ngIf="isRequired('phone')">*</span></label>
        <div class="control">
            <input formControlName="phone" [ngClass]="isFormRequestError('address.phone') ? 'is-danger' : ''"
                   class="input"
                   type="text"
                   placeholder="Telefon" value=""/>
            <p *ngIf="isFormRequestError('address.phone')"
               class="help is-danger">{{ this.getFieldErrorMsg('phone', 'Bitte hinterlegen Sie eine gültige Telefonnummer.') }}</p>
        </div>
    </div>
    <div *ngIf="guestAvailable" class="field">
        <label class="container-label-checkbox-guest checkbox">
            <input type="checkbox" (change)="setGuest(!isGuest)" formControlName="guest">
            Ich möchte als Gast bestellen
        </label>
    </div>
    <div class="is-flex-tablet">
        <div class="field is-flex-grow-1 pr-2-tablet">
            <label class="label">E-Mail*</label>
            <div class="control">
                <input formControlName="email" [ngClass]="isFormRequestError('email') ? 'is-danger' : ''" class="input"
                       type="email"
                       placeholder="Ihre E-Mail-Adresse" value=""/>
                <p *ngIf="isFormRequestError('email')" class="help is-danger">Bitte hinterlegen Sie eine
                    E-Mail-Adresse.</p>
                <p *ngIf="isFormRequestApiError('email')" class="help is-danger">Die E-Mail-Adresse existiert
                    bereits.<br><a
                            routerLink="/user/password-lost">Passwort vergessen?</a></p>
            </div>
        </div>
        <div *ngIf="!isGuest" class="field is-flex-grow-1 ml-4-tablet">
            <label class="label">Passwort*</label>
            <div class="control">
                <p-password formControlName="password" weakLabel="Schwaches Passwort" ariaLabel="Passwort vergeben"
                            mediumLabel="Mittelstarkes Passwort" class="primeng-password is-small"
                            strongLabel="Starkes Passwort" promptLabel="Hinterlegen Sie ein Passwort"
                            [toggleMask]="true"/>
                <p *ngIf="isFormRequestError('password')" class="help is-danger">Bitte hinterlegen Sie ein Passwort mit
                    mindestens 6 Zeichen.</p>
            </div>
        </div>
    </div>
    <p class="subtitle mt-4 your-address"><b>Ihre Adresse</b></p>
    <div class="field">
        <label class="checkbox">
            <input type="checkbox" (change)="toggleDeliveryAddress()">
            Die Lieferadresse weicht von der Rechnungsadresse ab
        </label>
    </div>
    <div formGroupName="address" class="address">
        <div class="field" [ngClass]="isHiddenOrDisabled('street')? 'is-hidden': ''">
            <label class="label">Straße und Hausnummer<span *ngIf="isRequired('street')">*</span></label>
            <div class="control">
                <input formControlName="street" [ngClass]="isFormRequestError('address.street') ? 'is-danger' : ''"
                       class="input" type="text"
                       placeholder="Straße und Hausnummer" value=""/>
                <p *ngIf="isFormRequestError('address.street')"
                   class="help is-danger">{{ this.getFieldErrorMsg('street', 'Bitte hinterlegen Sie eine Straße.') }}</p>
            </div>
        </div>
        <div class="is-flex-tablet" [ngClass]="isHiddenOrDisabled('postcode')? 'is-hidden': ''">
            <div class="field is-flex-grow-1 pr-2-tablet">
                <label class="label">Postleitzahl<span *ngIf="isRequired('postcode')">*</span></label>
                <div *ngIf="getDeliveryPostcodesGroup().length > 0 && !isDeliveryAddress && !deliveryTourService.getSelectedDeliveryTour().value?.pickupTour "
                     class="select" [ngClass]="isFormRequestError('address.postcode') ? 'is-danger' : ''">
                    <select formControlName="postcode" aria-label="Ihre Postleitzahl">
                        <option>Bitte auswählen</option>
                        <option *ngFor="let postcode of getDeliveryPostcodesGroup() ">{{ postcode }}</option>
                    </select>
                </div>
                <div *ngIf="getDeliveryPostcodesGroup().length <= 0 || isDeliveryAddress || deliveryTourService.getSelectedDeliveryTour().value?.pickupTour"
                     class="control">
                    <input formControlName="postcode"
                           [ngClass]="isFormRequestError('address.postcode') ? 'is-danger' : ''"
                           class="input" type="text"
                           placeholder="Postleitzahl" value=""/>
                    <p *ngIf="isFormRequestError('address.postcode')"
                       class="help is-danger">{{ this.getFieldErrorMsg('postcode', 'Bitte hinterlegen Sie eine Postleitzahl.') }}
                        .</p>
                </div>
            </div>
            <div class="field is-flex-grow-1 ml-4-tablet" [ngClass]="isHiddenOrDisabled('town')? 'is-hidden': ''">
                <label class="label">Ort<span *ngIf="isRequired('town')">*</span></label>
                <ng-container
                        *ngIf="getDeliveryPostcodesGroup().length > 0 && !isDeliveryAddress && !deliveryTourService.getSelectedDeliveryTour().value?.pickupTour">
                    <p *ngIf="getDeliveryTownsByPostcode(form.get('address.postcode')?.value ?? '').length <= 0">Bitte
                        Postleitzahl auswählen</p>
                    <div *ngIf="getDeliveryTownsByPostcode(form.get('address.postcode')?.value ?? '').length > 0"
                         class="select" [ngClass]="isFormRequestError('address.town') ? 'is-danger' : ''">
                        <select formControlName="town" aria-label="Ihr Ort">
                            <option value="">Bitte auswählen</option>
                            <option *ngFor="let town of getDeliveryTownsByPostcode(form.get('address.postcode')?.value ?? '') ">{{ town }}</option>
                        </select>
                    </div>
                </ng-container>

                <div *ngIf="getDeliveryPostcodesGroup().length <= 0 || isDeliveryAddress || deliveryTourService.getSelectedDeliveryTour().value?.pickupTour"
                     class="control">
                    <input formControlName="town" [ngClass]="isFormRequestError('address.town') ? 'is-danger' : ''"
                           class="input"
                           type="text"
                           placeholder="Ort" value=""/>

                </div>
                <p *ngIf="isFormRequestError('address.town')"
                   class="help is-danger">{{ this.getFieldErrorMsg('town', 'Bitte hinterlegen Sie einen Ort.') }}.</p>
            </div>
        </div>
        <div class="is-flex-tablet">
            <div class="field is-flex-grow-1 pr-2-tablet" [ngClass]="isHiddenOrDisabled('floor')? 'is-hidden': ''">
                <label class="label">Etage<span *ngIf="isRequired('floor')">*</span></label>
                <div class="control">
                    <input formControlName="floor"
                           [ngClass]="isFormRequestError('address.floor') ? 'is-danger' : ''"
                           class="input" type="number"
                           placeholder="Etage" value="0"/>
                    <p *ngIf="isFormRequestError('address.floor')"
                       class="help is-danger">{{ this.getFieldErrorMsg('floor', 'Bitte hinterlegen Sie eine Etage.') }}
                        .</p>
                </div>
            </div>
            <div class="field is-flex-grow-1 ml-4-tablet" [ngClass]="isHiddenOrDisabled('elevator')? 'is-hidden': ''">
                <label class="label">Aufzug<span *ngIf="isRequired('elevator')">*</span></label>
                <div class="control">
                    <div class="select" [ngClass]="isFormRequestError('address.elevator') ? 'is-danger' : ''">
                        <select formControlName="elevator" aria-label="Aufzug vorhanden">
                            <option [value]="null">Bitte auswählen</option>
                            <option [value]="true">Ja</option>
                            <option [value]="false">Nein</option>
                        </select>
                    </div>
                    <p *ngIf="isFormRequestError('address.elevator')"
                       class="help is-danger">{{ this.getFieldErrorMsg('elevator', 'Bitte geben Sie an, ob Sie über einen Aufzug verfügen.') }}</p>
                </div>
            </div>
        </div>
        <div *ngIf="countries.length > 0" class="field mt-3-touch"
             [ngClass]="isHiddenOrDisabled('country')? 'is-hidden': ''">
            <label class="label">Land<span *ngIf="isRequired('country')">*</span></label>
            <div class="control">
                <div class="select" [ngClass]="isFormRequestError('address.country') ? 'is-danger' : ''">
                    <select formControlName="country" aria-label="Ihr Land">
                        <option *ngIf="countries.length > 1" [value]="null">Bitte auswählen</option>
                        <option *ngFor="let country of countries" value="{{country}}">{{ country }}</option>
                    </select>
                </div>
                <p *ngIf="isFormRequestError('address.country')"
                   class="help is-danger">{{ this.getFieldErrorMsg('country', 'Bitte hinterlegen Sie ein Land.') }}.</p>
            </div>
        </div>
    </div>

    <div [ngClass]="isDeliveryAddress ? '' : 'is-hidden'" formGroupName="deliveryAddress">
        <p class="subtitle mt-4"><b>Lieferadresse</b></p>
        <div class="field" [ngClass]="isHiddenOrDisabled('salutation')? 'is-hidden': ''">
            <label class="label">Anrede<span *ngIf="isRequired('salutation')">*</span></label>
            <div class="control">
                <div class="select" [ngClass]="isFormRequestError('deliveryAddress.salutation') ? 'is-danger' : ''">
                    <select formControlName="salutation" aria-label="Anrede">
                        <option value="">Bitte auswählen</option>
                        <option value="Frau">Frau</option>
                        <option value="Herr">Herr</option>
                        <option value="Divers">Divers</option>
                    </select>
                </div>
                <p *ngIf="isFormRequestError('deliveryAddress.salutation')"
                   class="help is-danger">{{ this.getFieldErrorMsg('salutation', 'Bitte hinterlegen Sie eine Anrede.') }}</p>
            </div>

        </div>
        <div class="is-flex-tablet">
            <div class="field is-flex-grow-1" [ngClass]="isHiddenOrDisabled('firstName')? 'is-hidden': ''">
                <label class="label">Vorname<span *ngIf="isRequired('firstName')">*</span></label>
                <div class="control">
                    <input formControlName="firstName"
                           [ngClass]="isFormRequestError('deliveryAddress.firstName') ? 'is-danger' : ''" class="input"
                           type="text"
                           placeholder="Vorname" value=""/>
                    <p *ngIf="isFormRequestError('deliveryAddress.firstName')"
                       class="help is-danger">{{ this.getFieldErrorMsg('firstName', 'Bitte hinterlegen Sie einen Vornamen.') }}</p>
                </div>
            </div>
            <div class="field is-flex-grow-1 ml-4-tablet" [ngClass]="isHiddenOrDisabled('name')? 'is-hidden': ''">
                <label class="label">Nachname<span *ngIf="isRequired('name')">*</span></label>
                <div class="control">
                    <input formControlName="name"
                           [ngClass]="isFormRequestError('deliveryAddress.name') ? 'is-danger' : ''"
                           class="input" type="text"
                           placeholder="Nachname" value=""/>
                    <p *ngIf="isFormRequestError('deliveryAddress.name')"
                       class="help is-danger">{{ this.getFieldErrorMsg('name', 'Bitte hinterlegen Sie einen Namen.') }}</p>
                </div>
            </div>
        </div>
        <div class="field" [ngClass]="isHiddenOrDisabled('company')? 'is-hidden': ''">
            <label class="label">Firma<span *ngIf="isRequired('company')">*</span></label>
            <div class="control">
                <input formControlName="company" class="input" type="text" placeholder="Firma" value=""
                       [ngClass]="isFormRequestError('deliveryAddress.company') ? 'is-danger' : ''"/>
            </div>
            <p *ngIf="isFormRequestError('deliveryAddress.company')"
               class="help is-danger">{{ this.getFieldErrorMsg('company', 'Bitte hinterlegen Sie eine Firma.') }}.</p>
        </div>
        <div class="field" [ngClass]="isHiddenOrDisabled('street')? 'is-hidden': ''">
            <label class="label">Straße und Hausnummer<span *ngIf="isRequired('street')">*</span></label>
            <div class="control">
                <input formControlName="street"
                       [ngClass]="isFormRequestError('deliveryAddress.street') ? 'is-danger' : ''"
                       class="input" type="text"
                       placeholder="Straße und Hausnummer" value=""/>
                <p *ngIf="isFormRequestError('deliveryAddress.street')"
                   class="help is-danger">{{ this.getFieldErrorMsg('street', 'Bitte hinterlegen Sie eine Straße und Hausnummer.') }}</p>
            </div>
        </div>
        <div class="is-flex-tablet">
            <div class="field is-flex-grow-1" [ngClass]="isHiddenOrDisabled('postcode')? 'is-hidden': ''">
                <label class="label">Postleitzahl<span *ngIf="isRequired('postcode')">*</span></label>
                <div *ngIf="getDeliveryPostcodesGroup().length > 0 && !deliveryTourService.getSelectedDeliveryTour().value?.pickupTour "
                     class="select" [ngClass]="isFormRequestError('deliveryAddress.postcode') ? 'is-danger' : ''">
                    <select formControlName="postcode" aria-label="Ihre Postleitzahl">
                        <option>Bitte auswählen</option>
                        <option *ngFor="let postcode of getDeliveryPostcodesGroup() ">{{ postcode }}</option>
                    </select>
                </div>
                <div *ngIf="getDeliveryPostcodesGroup().length <= 0 || deliveryTourService.getSelectedDeliveryTour().value?.pickupTour"
                     class="control">
                    <input formControlName="postcode"
                           [ngClass]="isFormRequestError('deliveryAddress.postcode') ? 'is-danger' : ''"
                           class="input" type="text"
                           placeholder="Postleitzahl" value=""/>

                </div>
                <p *ngIf="isFormRequestError('deliveryAddress.postcode')"
                   class="help is-danger">{{ this.getFieldErrorMsg('postcode', 'Bitte hinterlegen Sie eine Postleitzahl.') }}</p>
            </div>
            <div class="field is-flex-grow-1 ml-4-tablet" [ngClass]="isHiddenOrDisabled('town')? 'is-hidden': ''">
                <label class="label">Ort<span *ngIf="isRequired('town')">*</span></label>
                <ng-container
                        *ngIf="getDeliveryPostcodesGroup().length > 0 && !deliveryTourService.getSelectedDeliveryTour().value?.pickupTour ">
                    <p *ngIf="getDeliveryTownsByPostcode(form.get('deliveryAddress.postcode')?.value ?? '').length <= 0">
                        Bitte Postleitzahl auswählen</p>
                    <div *ngIf="getDeliveryTownsByPostcode(form.get('deliveryAddress.postcode')?.value ?? '').length > 0"
                         class="select" [ngClass]="isFormRequestError('deliveryAddress.town') ? 'is-danger' : ''">
                        <select formControlName="town" aria-label="Ihr Ort">
                            <option>Bitte auswählen</option>
                            <option *ngFor="let town of getDeliveryTownsByPostcode(form.get('deliveryAddress.postcode')?.value ?? '') " [value]="town">{{ town }}</option>
                        </select>
                    </div>
                </ng-container>

                <div *ngIf="getDeliveryPostcodesGroup().length <= 0 || deliveryTourService.getSelectedDeliveryTour().value?.pickupTour"
                     class="control">
                    <input formControlName="town"
                           [ngClass]="isFormRequestError('deliveryAddress.town') ? 'is-danger' : ''"
                           class="input"
                           type="text"
                           placeholder="Ort" value=""/>

                </div>
                <p *ngIf="isFormRequestError('deliveryAddress.town')"
                   class="help is-danger">{{ this.getFieldErrorMsg('town', 'Bitte hinterlegen Sie einen Ort.') }}</p>
            </div>
        </div>
        <div class="is-flex-tablet">
            <div class="field is-flex-grow-1 pr-2-tablet" [ngClass]="isHiddenOrDisabled('floor')? 'is-hidden': ''">
                <label class="label">Etage<span *ngIf="isRequired('floor')">*</span></label>
                <div class="control">
                    <input formControlName="floor"
                           [ngClass]="isFormRequestError('deliveryAddress.floor') ? 'is-danger' : ''"
                           class="input" type="number"
                           placeholder="Etage" value="0"/>
                    <p *ngIf="isFormRequestError('deliveryAddress.floor')"
                       class="help is-danger">{{ this.getFieldErrorMsg('floor', 'Bitte hinterlegen Sie eine Etage.') }}</p>
                </div>
            </div>
            <div class="field is-flex-grow-1 ml-4-tablet" [ngClass]="isHiddenOrDisabled('elevator')? 'is-hidden': ''">
                <label class="label">Aufzug<span *ngIf="isRequired('elevator')">*</span></label>
                <div class="control">
                    <div class="select" [ngClass]="isFormRequestError('deliveryAddress.elevator') ? 'is-danger' : ''">
                        <select formControlName="elevator" aria-label="Aufzug vorhanden">
                            <option [value]="null">Bitte auswählen</option>
                            <option [value]="true">Ja</option>
                            <option [value]="false">Nein</option>
                        </select>
                    </div>
                    <p *ngIf="isFormRequestError('deliveryAddress.elevator')"
                       class="help is-danger">{{ this.getFieldErrorMsg('elevator', 'Bitte geben Sie an, ob Sie über einen Aufzug verfügen') }}
                        .</p>
                </div>
            </div>
        </div>
        <div *ngIf="countries.length > 0" class="field mb-4 mt-3-touch"
             [ngClass]="isHiddenOrDisabled('country')? 'is-hidden': ''">
            <label class="label">Land<span *ngIf="isRequired('country')">*</span></label>
            <div class="control">
                <div class="select" [ngClass]="isFormRequestError('deliveryAddress.country') ? 'is-danger' : ''">
                    <select formControlName="country" aria-label="Ihr Land">
                        <option *ngIf="countries.length > 1" [value]="null">Bitte auswählen</option>
                        <option *ngFor="let country of countries" value="{{country}}">{{ country }}</option>
                    </select>
                </div>
                <p *ngIf="isFormRequestError('deliveryAddress.country')"
                   class="help is-danger">{{ this.getFieldErrorMsg('country', 'Bitte hinterlegen Sie ein Land.') }}</p>
            </div>
        </div>
    </div>
    <ng-container
            *ngIf="(config$ | async)?.customerRegisterTextBottom && ((config$ | async)?.customerRegisterTextBottom?.length ?? 0) >0">
        <div class="mt-4" [innerHTML]="(config$ | async)?.customerRegisterTextBottom"></div>
    </ng-container>
    <div class="mt-4" [ngClass]="da.dynamicArticles.length > 0 ? '': 'is-hidden'">
        <iw-shop-customer-dynamic-articles #da
                                           (onChangeCustomerDynamicArticleIds)="form.get('dynamicArticleIds')?.setValue($event)"></iw-shop-customer-dynamic-articles>
    </div>

    <div class="mt-4 " *ngIf="!captcha">
        <div>
            <iw-shop-captcha-without-captcha (isVerified)="setCaptcha($event)"
                             [error]="(formStatus == 'submitForm' && !captcha)"></iw-shop-captcha-without-captcha>
        </div>
        <article *ngIf="formStatus == 'submitForm' && !captcha" class="message is-danger">
            <div class="message-body">
                Bitte bestätigen Sie, dass Sie kein Roboter sind.
            </div>
        </article>
    </div>
    <label class=" checkbox mt-4">
        <input type="checkbox" formControlName="terms">
        <span class="label-checkbox-terms-and-conditions">
            Ich habe die <a href="/datenschutzerklaerung" target="_blank" rel="nofollow">Datenschutzerklärung</a> zur
        Kenntnis genommen und die <a
                href="/agb" target="_blank" rel="nofollow">AGB</a> gelesen und bin mit ihnen einverstanden.
        <article *ngIf="isFormRequestError('terms')" class="message is-danger">
            <div class="message-body">
                Bitte bestätigen Sie, dass Sie die <a routerLink="/datenschutzerklaerung">Datenschutzerklärung</a> und
                <a routerLink="/agb">AGB</a> zur Kenntnis genommen haben.
            </div>
        </article>
        </span>

    </label>
    <div class="mt-4 pb-6">
        <iw-shop-forms-submit-button [formStatus]="formStatus" [submitLabel]="submitLabel"
                                     (submit)="register()"></iw-shop-forms-submit-button>
        <p class="mt-4 has-text-right">* Erforderliche Felder.</p>
    </div>


</div>


